module.exports = __webpack_public_path__ + "img/careers-banner.c68dce16.jpg";